import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-742c5b95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container" }
const _hoisted_3 = { class: "header__nav" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = {
  key: 0,
  class: "header__options"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "text"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "b-icon user" }, null, -1))
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "BASF logo",
    src: _imports_0
  })
], -1))
const _hoisted_11 = { class: "header__container" }
const _hoisted_12 = { class: "header__nav" }
const _hoisted_13 = { class: "header__options" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "b-icon user" }, null, -1))
const _hoisted_15 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "header__title",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('main')))
          }, [
            _createElementVNode("img", {
              alt: _ctx.$t('header.title'),
              src: _ctx.currentTheme
            }, null, 8, _hoisted_4)
          ]),
          (_ctx.isLogged)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("ul", null, [
                  (_ctx.dqTeamAuthorized)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDqFilter && _ctx.toggleDqFilter(...args)))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["b-icon zoom-plus", { 'toggle_dq--on': _ctx.isDqFiltering }])
                          }, null, 2),
                          (_ctx.isDqFiltering)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "DQ"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userName), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("a", {
                      class: "b-icon home",
                      id: "header-home",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('main')))
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        {
                    value: 'Home',
                    class: 'custom-tooltip'
                  },
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("a", {
                      class: "b-icon settings",
                      id: "header-settings",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('settings')))
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        {
                    value: 'Settings',
                    class: 'custom-tooltip'
                  },
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("a", {
                      class: "b-icon exit",
                      id: "header-logout",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        {
                    value: 'Log out',
                    class: 'custom-tooltip'
                  },
                        void 0,
                        { top: true }
                      ]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["header header__sticky", { hidden: _ctx.scrollpx < 100 }])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.userName), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "b-icon home",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('main')))
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "b-icon settings",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('settings')))
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "b-icon exit",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                })
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}